module.exports = __webpack_public_path__ + "img/oppo.ef29ca10.jpg";